// src/components/Toast.tsx
// ✅ REFORMULADO: Feedback silencioso, sem emojis, profissional

import React, { useEffect } from 'react';
import { Check, AlertTriangle, Info } from 'lucide-react';
import './Toast.css';

interface ToastProps {
    message: string;
    type: 'success' | 'error' | 'info';
    onClose: () => void;
    duration?: number;
}

const Toast: React.FC<ToastProps> = ({ message, type, onClose, duration = 3000 }) => {
    const onCloseRef = React.useRef(onClose);
    onCloseRef.current = onClose;

    useEffect(() => {
        const timer = setTimeout(() => onCloseRef.current(), duration);
        return () => clearTimeout(timer);
    }, [duration]);

    const getIcon = () => {
        switch (type) {
            case 'success':
                return <Check size={18} />;
            case 'error':
                return <AlertTriangle size={18} />;
            case 'info':
                return <Info size={18} />;
        }
    };

    return (
        <div className={`toast toast-${type}`} onClick={onClose}>
            <div className="toast-icon">{getIcon()}</div>
            <span className="toast-message">{message}</span>
        </div>
    );
};

export default Toast;